<template>
  <div>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-documento-add
      block
      variant="relief-primary"
      class="btn-icon"
    >
      <feather-icon icon="FilePlusIcon" />
      <!-- Editar -->
    </b-button>

    <b-modal
      id="modal-documento-add"
      ok-title="guardar datos"
      ok-variant="relief-success"
      cancel-title="cancelar"
      cancel-variant="relief-danger"
      centered
      size="lg"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Agregar Documentos"
      @ok="validationForm"
    >
      <b-row>
        <b-col xl="2">
          <center>
            <h5>Req. </h5>
          </center>
        </b-col>
        <b-col xl="5">
          <h5>Tipo de Documento</h5>
        </b-col>
        <b-col xl="5">
          <h5>Subir un Nuevo Documento</h5>
        </b-col>
      </b-row>
      <hr>
      <validation-observer ref="formDocumentosAdd">
        <!-- <div v-if="documentsList.length !== 0"> -->
          <b-row
            v-for="(documento, index) in documentsList"
            :key="documento.id"
            ref="row"
          >
          <!-- {{documento}} -->
            <b-col xl="2"
              class="mb-1"
            >
            <center>
              <b-button
                :variant="documento.required ? 'success' : 'danger'"
                class="btn-icon rounded-circle"
              >
                <feather-icon :icon="documento.required ? 'CheckIcon' : 'XIcon'" />
              </b-button>
            </center>
            </b-col>
            <b-col xl="5">
              <h5>{{ documento.name }}</h5>
            </b-col>
            <b-col xl="5">
              <b-form>
                <validation-provider
                  :id="`input-provider-add-${documento.id}`"
                  #default="{ errors }"
                  :name="documento.name"
                  :rules="{
                    required: documento.required,
                  }"
                >
                    <!-- size: 5000,
                    ext: 'pdf', -->
                  <b-form-group>
                    <b-form-file
                      v-model="documento.upload.documento"
                      :id="`input-file-add-${index}`"
                      browse-text="Buscar"
                      :disabled="documento.url ? true  : false"
                      placeholder="selecciona un archivo"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-form>
            </b-col>
          </b-row>
        <!-- </div> -->
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton,
  // BAlert,
  BCol,
  BFormGroup,
  BForm,
  BFormFile,
  BRow,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import PrebecarioService from '@/services/PrebecariosService'

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BButton,
    BCol,
    BFormGroup,
    BForm,
    BFormFile,
    BRow,
    ValidationObserver,
    ValidationProvider,
    BModal,
  },
  props: {
    curp: {
      type: String,
      required: true,
    },
    current: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      documentsList: [],
    }
  },
  mounted() {
    const vm = this
    vm.documentsList = vm.current
    vm.documentsList.forEach(e => {
      const upload = {
        prebecario: this.curp,
        tipo_documento_id: e.documentoId,
        documento: null,
      }
      e.upload = upload
    })
  },
  methods: {
    msg({ title, text, icon }) {
      return this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    validationForm(bvModalEvt) {
      bvModalEvt.preventDefault()
      // this.$refs.formDocumentosAdd.validate().then(success => {
      //   if (success) {
      this.status = false
      this.documentsList.forEach(async e => {
        if (e.upload.documento) await this.saveDocumentos(e.upload)
      })
      this.$bvModal.hide('modal-documento-add')
      this.msg({
        title: 'OK!',
        text: 'Se guardaron correctamente los documentos!',
        icon: 'success',
      })
      // } else {
      //   this.status = true
      // }
      // })
    },
    saveDocumentos(data) {
      const formData = new FormData()
      formData.append('prebecario', data.prebecario)
      formData.append('documento', data.documento)
      formData.append('tipo_documento_id', data.tipo_documento_id)
      PrebecarioService.saveDocumento(formData)
        .then(resp => {
          if (resp.status === 201) {
            this.$emit('update', resp.data)
            // this.$emit('update', {
            //   type: 1,
            //   data: resp.data,
            // })
            // const nivelEstudios = this.catNivelEstudios.find(element => element.id === resp.data.nivel_estudios)
            // const tipoComprobante = this.catComprobanteEstudios.find(element => element.id === resp.data.tipo_comprobante)
            // this.$emit('update', { nivelEstudios, tipoComprobante })
            // this.msg({
            //   title: 'OK!',
            //   text: 'Se guardaron correctamente los documentos!',
            //   icon: 'success',
            // })
          }
        })
        .catch(() => {
          this.msg({
            title: 'Error!',
            text: 'Lo sentimos algo salio mal cargango los archivos!',
            icon: 'error',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';

pre {
  min-height: 295px;
  padding: 1.5rem;
  margin-bottom: 0;
  border-radius: 0.5rem;
}
</style>
